module.exports = __webpack_public_path__ + "static/media/Group 37400.cfc5f6bc.png";